// extracted by mini-css-extract-plugin
export default {"item":"styles_item__8bGe2","left":"styles_left__iQcGs","right":"styles_right__I3XJ7"};